import { render, staticRenderFns } from "./AddSupplierModal.vue?vue&type=template&id=58386d80&scoped=true"
import script from "./AddSupplierModal.vue?vue&type=script&lang=js"
export * from "./AddSupplierModal.vue?vue&type=script&lang=js"
import style0 from "./AddSupplierModal.vue?vue&type=style&index=0&id=58386d80&prod&lang=scss&scoped=true"
import style1 from "./AddSupplierModal.vue?vue&type=style&index=1&id=58386d80&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58386d80",
  null
  
)

export default component.exports